<div class="content">
  <div class="wz-head">
    <span class="wz-eyebrow">World Creation Wizard</span>
    <h2 class="wz-title">Before you <span class="gold">continue</span></h2>
  </div>

  <div class="wz-choice">
    <div class="wz-choice-chips">
      <span class="wz-chip">Uses 1 credit</span>
    </div>
    <h3 class="wz-choice-name">One-time setup for {{ mapName }}</h3>
    <p class="wz-lead">
      A World Initialization Credit runs a one-time process that fills your world with its first cultures, religions,
      states and provinces.
    </p>
  </div>

  <div class="wz-note" role="note">
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5v.01"/></svg>
    <p><strong>The credit is used up for good</strong> when your world is created, even if you delete the world later. You can buy more credits at any time.</p>
  </div>

  <div class="wz-stats">
    <div class="wz-stat">
      <span>Credits needed</span>
      <strong>1</strong>
    </div>
    <div class="wz-stat">
      <span>Your balance</span>
      @if (isLoading) {
        <i class="wz-spinner" aria-label="Loading"></i>
      } @else {
        <strong>{{ worldCredits }}</strong>
      }
    </div>
  </div>

  <div class="wz-actions">
    <button type="button" class="btn btn-dark" (click)="onBack()">Back</button>
    <button type="button" class="btn btn-theme" (click)="onProceed()">I understand, continue</button>
  </div>
</div>
